import axios from 'axios';

export default axios.create({
    baseURL: `https://api.arglobe.cn/`,
    proxy: false,
    headers:{
        'Access-Control-Allow-Origin': '*',
    }
});
